export const PAYMENT_STATUS_OPTIONS = ['init', 'pending', 'succeed', 'failed'];
